import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Set mock tokens IMMEDIATELY if in mock mode (before any React code runs)
if (process.env.REACT_APP_USE_MOCKS === 'true') {
  console.log('[MOCK] Setting tokens BEFORE React initialization...');
  localStorage.setItem('concerto_auth_token', 'mock-access-token');
  localStorage.setItem('concerto_refresh_token', 'mock-refresh-token');
  localStorage.setItem('concerto_user', JSON.stringify({
    id: 'test-user-id',
    email: 'test@example.com',
    name: 'Test User',
    created_at: '2024-01-01T00:00:00Z',
  }));
  console.log('[MOCK] Tokens set!');
}

// Enable MSW mocks in development if REACT_APP_USE_MOCKS is set
async function enableMocking() {
  if (process.env.REACT_APP_USE_MOCKS !== 'true') {
    return;
  }

  console.log('[MOCK] Starting MSW worker...');
  const { worker } = await import('./mocks/browser');
  await worker.start({
    onUnhandledRequest: 'bypass', // Don't warn about unhandled requests
  });
  console.log('[MOCK] MSW worker started');
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

enableMocking().then(() => {
  root.render(
    // Temporarily disable StrictMode to debug double-render issue
    // <React.StrictMode>
      <App />
    // </React.StrictMode>
  );
});

